/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
/*
  This Dropdown component used to select the option value from the list of records / data
  onChangeHandler : onChangeHandler is callback function recieved from parent component for send the user selected value to parent component
  Field           : Field props recieved from parent component with datasource
  className       : className props recieved from parent component for display and modify the style based on parent component
*/

import React from 'react'
import PropTypes from 'prop-types'
import { FormControl, Select, MenuItem, InputLabel } from '@material-ui/core'
import HelpText from '../helpText/HelpText'
import utils from '../../../../utils/utils'
import './Dropdown.css'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'

//className, fieldErrorMessage
function Dropdown({
  Field,
  value,
  onChangeHandler,
  variant,
  onBlur,
  outlineError,
  required,
  restrictSorting = false,
  ...rest
}) {
  let dataSource = Array.isArray(Field?.datasource) ? Field?.datasource : []
  if (!restrictSorting)
    dataSource = utils?.sortArrayOfObjects(dataSource, Field?.textField)
  outlineError?.splice(1)
  /*
    This is used to generate templete to display the control's lable, requried fiels symbol, field error message and help text
  */
  const controlLabel = (
    <div className="controlLabelDiv">
      <span className="controlLabel">{Field && Field?.fieldLabel}</span>
      <span>{outlineError && outlineError}</span>
      <span>
        {Field && Field?.helpText && <HelpText longText={Field?.helpText} />}
      </span>
      {required || Field?.validation?.isRequired?.toLowerCase() === 'true' ? (
        <span className="Required-color"> *</span>
      ) : (
        ''
      )}
    </div>
  )

  /*
   This onChange function used to pass the selected value to parent component via callback function (onChangeHandler)
  */
  function onChange(event) {
    if (onChangeHandler)
      onChangeHandler(event, {
        id: Field?.fieldValue,
        value: event?.target?.value,
        type: 'select',
        textValue: event?.currentTarget?.outerText,
      })
  }

  return (
    <div className="dropdownctrl">
      <div
        className={`Text-field-container ${Field.className}`}
        style={{ height: '100%' }}
      >
        <FormControl
          size="small"
          variant={variant || 'filled'}
          className={`${Field?.className} ${'dropdown'}`}
          style={{ height: 'inherit' }}
          // required={required}
        >
          <InputLabel id="demo-simple-select-outlined-label">
            {controlLabel}
          </InputLabel>
          <Select
            indicator={<ArrowDropDownIcon />}
            id={Field?.fieldValue}
            className={Field?.className}
            variant="filled"
            MenuProps={{
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              PaperProps: {
                className: `${
                  Field?.scrollHeight === 'ContactAddress_country'
                    ? 'ddl_ListData'
                    : ''
                }`,
                style: Field?.menuPaperStyle,
              },
              getContentAnchorEl: null,
            }}
            onChange={(e) => onChange(e)}
            label={controlLabel}
            disabled={Field?.disabled}
            defaultValue={Field?.defaultValue}
            value={value}
            disableUnderline
            onBlur={onBlur}
            displayEmpty
            inputProps={{
              'data-testid': rest?.dataTestId
                ? rest?.dataTestId
                : 'SelectElement',
            }}
            renderValue={(value) => {
              if (value === '' && Field?.placeholder?.length > 0) {
                return (
                  <em>
                    <p>{Field?.placeholder}</p>
                  </em>
                )
              }
              return (
                <p>
                  {
                    dataSource?.find(
                      (item) =>
                        item?.hasOwnProperty(Field?.valueField) &&
                        item[Field?.valueField] === value
                    )?.[Field?.textField]
                  }
                </p>
              )
            }}
          >
            {dataSource &&
              dataSource?.map((option, idx) => {
                return (
                  <MenuItem
                    key={`${option?.[Field?.valueField] ?? ''}_${idx + 1}`}
                    value={option?.[Field?.valueField] ?? ''}
                    name={option?.[Field?.textField] ?? ''}
                    className="dropdownOptionMenuItem"
                  >
                    <span className="dropdownOptionText">
                      {option?.[Field?.textField] ?? ''}
                    </span>
                  </MenuItem>
                )
              })}
          </Select>
        </FormControl>
      </div>
    </div>
  )
}

Dropdown.defaultProps = {
  className: '',
  value: '',
  onChangeHandler: () => {},
}
Dropdown.propTypes = {
  Field: PropTypes.shape({
    fieldValue: PropTypes.string.isRequired,
    fieldLabel: PropTypes.string,
    textField: PropTypes.string,
    valueField: PropTypes.string,
    datasource: PropTypes.arrayOf(PropTypes.object),
    disabled: PropTypes.bool,
  }).isRequired,
  value: PropTypes.string,
  onChangeHandler: PropTypes.func,
  className: PropTypes.string,
}
export default Dropdown
